import { createSlice } from '@reduxjs/toolkit';
import { createChangeAdvertiseMediaPosition } from './api';
import { initialState } from './api/interface';

const changeAdvertiseMediaPositionSlice = createSlice({
  name: 'changeAdvertiseMediaPosition',
  initialState,
  reducers: {
    setLimit: (state, action) => {
      state.limit = action.payload.limit;
      state.status = 'idle';
    },
    setSkip: (state, action) => {
      state.skip = action.payload.skip;
      state.status = 'idle';
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload.currentPage;
    },
    setStatus: (state, action) => {
      state.status = action.payload.status;
    },
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(createChangeAdvertiseMediaPosition.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(createChangeAdvertiseMediaPosition.fulfilled, (state, action) => {
      state.data.push(action.payload);
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
    });
    builder.addCase(createChangeAdvertiseMediaPosition.rejected, (state, _) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
    });

  },
});

export const { setLimit, setSkip, setCurrentPage, setStatus, reset } = changeAdvertiseMediaPositionSlice.actions;
export default changeAdvertiseMediaPositionSlice.reducer;
